import { createContext } from "react";

export const PageContext = createContext(false);

export const PageDrawerContext = createContext(false);
